module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-page"
  }, [_c('div', {
    staticClass: "register-form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.name),
      expression: "info.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的姓名"
    },
    domProps: {
      "value": (_vm.info.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.info.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.phone),
      expression: "info.phone"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "请输入您的电话"
    },
    domProps: {
      "value": (_vm.info.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.info.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.email),
      expression: "info.email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的邮箱"
    },
    domProps: {
      "value": (_vm.info.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.info.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.unit),
      expression: "info.unit"
    }],
    attrs: {
      "type": "text",
      "placeholder": "所在单位/学校名"
    },
    domProps: {
      "value": (_vm.info.unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.info.unit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.job),
      expression: "info.job"
    }],
    attrs: {
      "type": "text",
      "placeholder": "职位"
    },
    domProps: {
      "value": (_vm.info.job)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.info.job = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.password),
      expression: "info.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请填写6-12位密码"
    },
    domProps: {
      "value": (_vm.info.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.info.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.rePassword),
      expression: "info.rePassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请重新输入您的密码"
    },
    domProps: {
      "value": (_vm.info.rePassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.info.rePassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "other-option"
  }, [_c('div', {
    staticClass: "left-content"
  }), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("登录")]), _c('a', [_vm._v("|")]), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("注册")])])]), _vm._v(" "), _c('a', {
    staticClass: "form-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("\n      现在注册\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-logo"
  }, [_c('img', {
    attrs: {
      "src": require("assets/logo-login.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e022d36a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/register.vue
// module id = 814
// module chunks = 1